var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    }
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { BaseService } from '../base/base-service';
import { ConfigService } from './config.service';
import { Router } from '@angular/router';
import { NavController } from '@ionic/angular';
import { Subject } from 'rxjs';
import { Location } from '@angular/common';
import * as i0 from "@angular/core";
import * as i1 from "./config.service";
import * as i2 from "@angular/common";
import * as i3 from "@angular/router";
import * as i4 from "@ionic/angular";
/**
 *  Use this singleton service to maintain state, pass parameters between navigation
 * */
var NavigationService = /** @class */ (function (_super) {
    __extends(NavigationService, _super);
    function NavigationService(configs, location, router, navController) {
        var _this = _super.call(this) || this;
        _this.configs = configs;
        _this.location = location;
        _this.router = router;
        _this.navController = navController;
        // TODO : keep a copy of cache in localstorage to handle refresh?
        _this.cache = {};
        _this.navigating = false;
        _this.poping = false;
        // private pageStack: string[] = [];
        _this.deactivateResult = new Subject();
        _this.backByLocation = false;
        _this.isAlertingDeactive = false;
        _this.rootPageUrl = '';
        return _this;
    }
    NavigationService.prototype.popPage = function () {
        this.poping = true;
        console.log('poping');
        // this.navController.pop().then(() => {
        //     console.log('pop done', this.poping);
        //     // this.poping = false;
        // });
        this.navController.setDirection('back', true, 'back');
        this.location.back();
    };
    NavigationService.prototype.popToParent = function (route) {
        var _this = this;
        this.poping = true;
        this.navController.pop().then(function () {
            console.log('pop done', _this.poping);
            // this.poping = false;
        });
        // this.navController.setDirection('back');
        // this.router.navigate(['../'], {relativeTo: route, replaceUrl: true}).then(() => {
        // });
    };
    NavigationService.prototype.popToRoot = function () {
        this.poping = true;
        this.navController.setDirection('root', true, 'back');
        this.navController.navigateRoot(this.getRootPageUrl()).then(function () {
            // this.poping = false;
        });
    };
    NavigationService.prototype.configRootUrl = function () {
        console.log('config root url in navigationService');
        // TODO: config the root page
        /**
         *  check params to generate root page url
         *  /store/{id}/spot/{tableNo}
         *  /store/{id}/mode/{mode}
         *  /court-store-list/{id}/mode/{mode}
         *  /court-store-list//{id}/spot/{tableNo} ?
         *  please add more cases here
         * */
        var temp = window.location.pathname;
        var rootUrl = '';
        var storeIndex = temp.indexOf('store/');
        var courtIndex = temp.indexOf('court-store-list/');
        var modeEnd = 0;
        if (storeIndex !== -1) {
            rootUrl += 'store/';
            modeEnd = temp.indexOf('/', storeIndex + 6);
            rootUrl += temp.substring(storeIndex + 6, modeEnd);
        }
        else if (courtIndex !== -1) {
            rootUrl += 'court-store-list/';
            modeEnd = temp.indexOf('/', courtIndex + 17);
            rootUrl += temp.substring(courtIndex + 17, modeEnd);
        }
        var spotIndex = temp.indexOf('spot/');
        if (spotIndex !== -1) {
            rootUrl += '/spot/';
            modeEnd = temp.indexOf('/', spotIndex + 5);
            if (modeEnd !== -1) {
                rootUrl += temp.substring(spotIndex + 5, modeEnd);
            }
            else {
                rootUrl += temp.substring(spotIndex + 5);
            }
        }
        var courtModeIndex = temp.indexOf('court/'); // court  Mode
        if (courtModeIndex !== -1) {
            rootUrl += 'court/';
            modeEnd = temp.indexOf('/', courtModeIndex + 6);
            rootUrl += temp.substring(courtModeIndex + 6, modeEnd !== -1 ? modeEnd : temp.length + 1); // court/123231   后面没 /
        }
        var historyIndex = temp.indexOf('history/'); // court  Mode
        if (historyIndex !== -1) {
            // direct history page
            rootUrl += temp;
        }
        var keyIndex = temp.indexOf('key/');
        if (keyIndex !== -1) {
            rootUrl += '/key/';
            var keyEnd = temp.indexOf('/', keyIndex + 4);
            if (keyEnd !== -1) {
                rootUrl += temp.substring(keyIndex + 4, keyEnd);
            }
            else {
                rootUrl += temp.substring(keyIndex + 4);
            }
        }
        var modeIndex = temp.indexOf('mode/');
        if (modeIndex !== -1) {
            rootUrl += '/mode/';
            modeEnd = temp.indexOf('/', modeIndex + 5);
            if (modeEnd !== -1) {
                rootUrl += temp.substring(modeIndex + 5, modeEnd);
            }
            else {
                rootUrl += temp.substring(modeIndex + 5);
            }
        }
        this.setRootPageUrl(rootUrl);
        console.log('set root Url in navigation service', rootUrl);
        if (!document.getElementById('baseHref').href || document.getElementById('baseHref').href === '/') {
            document.getElementById('baseHref').href = rootUrl;
        }
    };
    NavigationService.prototype.setRootPageUrl = function (url) {
        if (!url) {
            console.log('wrong input root url, reject', url);
            return;
        }
        this.rootPageUrl = url;
        this.configs.setLocal('rootPage', this.rootPageUrl);
        console.log('set root page ', url);
    };
    NavigationService.prototype.getRootPageUrl = function (ignoreCache) {
        if (ignoreCache === void 0) { ignoreCache = false; }
        if (ignoreCache && !this.rootPageUrl) {
            this.rootPageUrl = this.configs.getLocal('rootPage');
        }
        return this.rootPageUrl;
    };
    NavigationService.prototype.setNavigationParams = function (params) {
        this.cache = params;
    };
    NavigationService.prototype.getNavigationParams = function () {
        return this.cache;
    };
    NavigationService.ngInjectableDef = i0.defineInjectable({ factory: function NavigationService_Factory() { return new NavigationService(i0.inject(i1.ConfigService), i0.inject(i2.Location), i0.inject(i3.Router), i0.inject(i4.NavController)); }, token: NavigationService, providedIn: "root" });
    return NavigationService;
}(BaseService));
export { NavigationService };
